import React from 'react';
import { styled } from '@compiled/react';
import { ModalBody } from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { VersionPickerProps as Props } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyVersionsPicker = lazy(() =>
	import(/* webpackChunkName: "async-version-picker" */ './index').then(
		(module) => module.VersionPicker,
	),
);

const LoadingModal = () => (
	<ModalBody>
		<LoadingWrapper>
			<Spinner size="large" />
		</LoadingWrapper>
	</ModalBody>
);

export const VersionPicker = (props: Props): React.JSX.Element => (
	<Placeholder name="version-picker" fallback={<LoadingModal />}>
		<LazyVersionsPicker {...props} />
	</Placeholder>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '160px',
});
